import React from 'react';
import FloatingTooltip from '#components/tooltip.jsx';
import { AddRowButton } from '#@itinerary/planner/row.jsx';
import { Icon } from '@iconify-icon/react';
import { cn } from '#lib/helpers/class.js';

export default function ProfilesList(props) {
    const { profiles, selectedProfileIndex, onAdd, onDelete, onClone, onSelect, unsavedChanges } = props;

    const handleCloneProfile = (profile) => {
        const confirm = window.confirm(_t.global.confirmClone());
        if (!confirm) return;
        onClone({ ...profile, isNew: true });
    };

    const handleDeleteProfile = (profile) => {
        const confirm = window.confirm(_t.global.confirmDelete());
        if (!confirm) return;
        onDelete(profile);
    };

    return (
        <>
            <ul className="w-full flex flex-col divide-y divide-neutral-200 border border-neutral-200 mb-2 rounded">
                {profiles.map((profile, index) => {
                    const selected = selectedProfileIndex === index;
                    return (
                        <li
                            key={profile.id}
                            className="pl-2 pb-1 pt-[6px] pr-1 w-full flex justify-between items-center cursor-pointer rounded bg-white hover:bg-neutral-200"
                            onClick={() => onSelect(index)}
                        >
                            <span
                                className={cn(
                                    'w-full overflow-hidden text-ellipsis whitespace-nowrap text-sm font-semibold',
                                    selected && 'text-primary-600'
                                )}
                            >
                                {profile.name}
                            </span>
                            <div className="flex gap-x-2">
                                <div>
                                    {profile.isDefault && (
                                        <FloatingTooltip
                                            content={_t.theme.favoriteProfile()}
                                            placement="top"
                                            refClassName="cursor-default"
                                        >
                                            <Icon
                                                icon="material-symbols:favorite-rounded"
                                                width="1.2rem"
                                                height="1.2rem"
                                                className="pt-[2px] text-[#c51111]"
                                            />
                                        </FloatingTooltip>
                                    )}
                                </div>
                                <FloatingTooltip
                                    content={unsavedChanges ? _t.edit.profilesClone() : _t.global.clone()}
                                    placement="top"
                                    refClassName={unsavedChanges ? 'cursor-default' : 'cursor-pointer'}
                                >
                                    <Icon
                                        icon="material-symbols:content-copy-outline-rounded"
                                        width="1.3rem"
                                        height="1.3rem"
                                        className={cn(
                                            unsavedChanges
                                                ? 'cursor-default text-neutral-400'
                                                : 'cursor-pointer hover:text-primary-600'
                                        )}
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            if (unsavedChanges) return;
                                            handleCloneProfile(profile);
                                        }}
                                    />
                                </FloatingTooltip>
                                <FloatingTooltip content={_t.global.delete()} placement="top">
                                    <Icon
                                        icon="ph:trash"
                                        width="1.3rem"
                                        height="1.3rem"
                                        className="cursor-pointer hover:text-primary-600"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            handleDeleteProfile(profile);
                                        }}
                                    />
                                </FloatingTooltip>
                            </div>
                        </li>
                    );
                })}
            </ul>
            <AddRowButton onClick={onAdd} />
        </>
    );
}
